module.exports = __webpack_public_path__ + "img/Confianza.dd75f8df.svg";